/**
 * Diet Builder Utilities for IronHUD (Alpine.js Components)
 */

export const FoodSearchComponent = () => ({
    open: false,
    selectedId: null,
    selectedName: '',
    query: '',
    results: [],
    loading: false,
    macros: { kcal: 0, p: 0, c: 0, f: 0 },
    _abortController: null,
    _debounceTimeout: null,

    init() {
        this.$watch('query', (val) => {
            if (!val || val.length < 2) {
                this.open = false;
                this.results = [];
                this.selectedId = null;
                this.selectedName = '';
                this.clearId();
                if (this._abortController) this._abortController.abort();
            } else {
                // Prevents automatic search on page load
                const input = this.$el.querySelector('input[name="item_description"]');
                if (document.activeElement !== input) {
                    return;
                }

                // If it matches the already selected item name, don't search again
                if (this.selectedId && val === this.selectedName) {
                    return;
                }

                this.selectedId = null;
                this.selectedName = '';
                this.clearId();

                clearTimeout(this._debounceTimeout);
                this._debounceTimeout = setTimeout(() => {
                    this.performSearch();
                }, 300);
            }
        });
    },

    async performSearch() {
        if (!this.query || this.query.length < 2) return;

        if (this._abortController) {
            this._abortController.abort();
        }
        this._abortController = new AbortController();

        this.loading = true;
        this.open = true;

        try {
            const response = await fetch(
                `/api/v1/diet/food/search?q=${encodeURIComponent(this.query)}`,
                {
                    signal: this._abortController.signal,
                }
            );
            const data = await response.json();

            if (!this._abortController.signal.aborted) {
                this.results = data.items;
            }
        } catch (e) {
            if (e.name !== 'AbortError') {
                console.error('Food search failed', e);
            }
        } finally {
            if (!this._abortController.signal.aborted) {
                this.loading = false;
            }
        }
    },

    clearId() {
        const row = this.$el.closest('.group\\/item');
        if (row) {
            const idInput = row.querySelector('input[name="food_id"]');
            if (idInput) idInput.value = '';
        }
    },

    selectFood(food) {
        this.selectedId = food.id;
        this.selectedName = food.name;
        this.query = food.name;
        this.macros = {
            kcal: food.energy_kcal || 0,
            p: food.protein_g || 0,
            c: food.carbohydrate_g || 0,
            f: food.lipid_g || 0,
        };
        this.open = false;

        // Populate hidden ID in the parent row
        const row = this.$el.closest('.group\\/item');
        if (row) {
            const idInput = row.querySelector('input[name="food_id"]');
            if (idInput) idInput.value = food.id;
        }
    },
});
